import { CLICKED_CONTINUE_BUTTON } from 'launch/consts/trackEventNames';
import { ContinueButton } from 'launch/components/BriefFooter';
import { OrderedSet } from 'immutable';
import { default as Section } from 'launch/components/AppSection';
import { intlShape, FormattedMessage, FormattedNumber } from 'react-intl';
import { trackEvent } from '@99designs/common/utils/platform';
import { transitionToNextStep, saveDraft } from 'launch/actions/designBriefActions';
import BriefBookTypeStore from 'launch/stores/BriefBookTypeStore';
import DraftStore from 'launch/stores/DraftStore';
import * as Footer from 'common/components/FooterBar';
import ImageTile from 'launch/components/ImageTile';
import { Matrix, MatrixItem } from 'common/components/Matrix';
import Mediabox from 'common/components/Mediabox';
import PropTypes from 'prop-types';
import React from 'react';
import * as bookTypeActions from 'launch/actions/bookTypeActions';
import connectToStores from 'fluxible-addons-react/connectToStores';

class BriefBookType extends React.Component {
    constructor(props) {
        super(props);

        this.nextStep = this.nextStep.bind(this);
    }

    nextStep() {
        const { selectedBookType } = this.props;

        trackEvent(CLICKED_CONTINUE_BUTTON, {
            step: 'book-type',
            selectedBookType,
            draft_hash: this.props.draftHash,
            category: this.props.categoryKey,
        });

        this.context.executeAction(transitionToNextStep, {
            saveAction: saveDraft,
            data: {
                book_type: selectedBookType,
            },
        });
    }

    selectBookType(bookType) {
        this.context.executeAction(bookTypeActions.selectBookType, bookType);
    }

    renderFooter() {
        return (
            <Footer.Footer>
                <Footer.Element align="right">
                    <ContinueButton
                        onClick={this.nextStep}
                        saving={this.props.saveInProgress}
                        disabled={!this.props.isStepComplete}
                    />
                </Footer.Element>
            </Footer.Footer>
        );
    }

    renderBookType(bookType) {
        let selected = this.props.selectedBookType === bookType.id;

        const price = (
            <FormattedNumber
                value={bookType.price.price}
                style="currency"
                currency={bookType.price.currency}
                minimumFractionDigits={0}
            />
        );

        return (
            <Mediabox
                variations={['linked']}
                selected={selected}
                onClick={this.selectBookType.bind(this, bookType.id)}
            >
                <ImageTile
                    url={bookType.url}
                    title={<FormattedMessage id={bookType.labelMessageId} />}
                    label={<FormattedMessage id="from_price" values={{ price }} />}
                />
            </Mediabox>
        );
    }

    render() {
        return (
            <div>
                <Section>
                    <Matrix large={3} medium={2} small={1} staggered={true}>
                        {this.props.bookTypes.map(bookType => (
                            <MatrixItem key={bookType.id}>
                                {this.renderBookType(bookType)}
                            </MatrixItem>
                        ))}
                    </Matrix>
                </Section>

                {this.renderFooter()}
            </div>
        );
    }
}

BriefBookType.propTypes = {
    saveInProgress: PropTypes.bool.isRequired,
    bookTypes: PropTypes.instanceOf(OrderedSet).isRequired,
    selectedBookType: PropTypes.string.isRequired,
    isStepComplete: PropTypes.bool.isRequired,
    draftHash: PropTypes.string,
    categoryKey: PropTypes.string,
};

BriefBookType.defaultProps = {
    draftHash: null,
    categoryKey: null,
};

BriefBookType.contextTypes = {
    intl: intlShape.isRequired,
    executeAction: PropTypes.func,
};

export default connectToStores(BriefBookType, [BriefBookTypeStore, DraftStore], function(
    context,
    props
) {
    const store = context.getStore(BriefBookTypeStore);

    return {
        bookTypes: store.bookTypes,
        selectedBookType: store.selectedBookType,
        isStepComplete: !!store.isStepComplete(),
        ...context.getStore(DraftStore).getState(),
    };
});

export const Component = BriefBookType;
